import { urlsServices } from '@/config/urls';
import axios from 'axios';

let httpUrl = `${urlsServices.GETWAY}api/registro-atendimento`;

export const createRegistroAtendimento = async (registroAtendimento) => {
  return await axios.post(`${httpUrl}/create`, registroAtendimento).then((response) => response);
};

export const getListProfissional = async (idProfissional) => {
  return await axios.get(`${httpUrl}/list-profissional/${idProfissional}`).then((response) => response);
};

export const getByIdRegistroAtendimento = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const getByIdAgendamentoMedico = async (idAgendamentoMedico) => {
  return await axios.get(`${httpUrl}/agendamento-medico/${idAgendamentoMedico}`).then((response) => response);
};

export const getUnidadeAtendimentoRelatorio = async (params) => {
  return await axios.put(`${httpUrl}/relatorio-unidade-atendimento`, params).then((response) => response);
};

export const getConvenioAtendimentoRelatorio = async (params) => {
  return await axios.put(`${httpUrl}/relatorio-convenio-atendimento`, params).then((response) => response);
};

export const getFuncoesAtuaisRelatorio = async (params) => {
  return await axios.put(`${httpUrl}/relatorio-funcao-atual-atendimento`, params).then((response) => response);
};

export const gerarRelatorioAtendimentoQtdePorCategoria = async (filtro) => {
  return await axios.post(`${httpUrl}/list-qtde-atendimento-categoria`, filtro).then((response) => response);
};

export const gerarRelatorioAtendimentoQtdePorPaciente = async (filtro) => {
  return await axios.post(`${httpUrl}/list-qtde-atendimento-paciente`, filtro).then((response) => response);
};
